const SHIPMENT_STATUS = {
  NEW: 'new',
  PACKED: 'packed',
  SENT: 'sent',
  ARRIVED: 'arrived',
  RECEIVED: 'received'
  // DELAYED: 'delayed' // TODO: new label to be added
  // CANCELED: 'canceled' this status is not needed yet
}

const SHIPMENT_STATUS_TO_LMD_DISPLAY_STATUS = {
  [SHIPMENT_STATUS.NEW]: 'Scheduled',
  [SHIPMENT_STATUS.PACKED]: 'Packed',
  [SHIPMENT_STATUS.SENT]: 'In transit',
  [SHIPMENT_STATUS.ARRIVED]: 'Arrived',
  [SHIPMENT_STATUS.RECEIVED]: 'Received'
  // [SHIPMENT_STATUS.DELAYED]: 'Delayed' // TODO: new label to be added
}

const SHIPMENT_STATUS_TO_LMD_DISPLAY_STATUS_FOR_DRIVER = {
  ...SHIPMENT_STATUS_TO_LMD_DISPLAY_STATUS,
  [SHIPMENT_STATUS.RECEIVED]: 'Completed'
}

const SHIPMENT_ADVANCE_STATUSES = {
  new: SHIPMENT_STATUS.PACKED,
  packed: SHIPMENT_STATUS.SENT,
  sent: SHIPMENT_STATUS.ARRIVED,
  arrived: SHIPMENT_STATUS.RECEIVED
}

const SHIPMENT_ADJUSTMENT_REASONS = {
  quantity_missing: 'Quantity missing',
  units_damaged: 'Units damaged',
  units_with_broken_packaging: 'Units with broken packaging',
  units_expired: 'Units expired',
  incorrect_items_received: 'Incorrect item received',
  quantity_over_needed: `Quantity is over what's needed`,
  other: 'Other'
}

const SHIPMENT_GPS_FAIL_REASONS = {
  technical_dificulty: 'GPS or app technical dificulties',
  facility_request: 'Request from facility rep',
  access_restriction: 'Physical barriers, access restriction or outside business hours',
  location_closed: 'Delivery location was closed',
  safety_risk: 'Safety risk',
  traffic_conditions: 'Traffic or road conditions',
  permission_denied: 'Location permission was denied',
  location_coordinates_missing: 'Facility location coordinates not available',
  warehouse_location_coordinates_missing: 'Warehouse location coordinates not available'
}

// Reasons recorded silently by the system (not driver-selectable) - they are
// filtered out of the reason picker. Keys must match SHIPMENT_GPS_FAIL_REASONS
// so the web UI can reference this single source instead of re-listing them.
const SHIPMENT_GPS_SILENT_REASONS = [
  'permission_denied',
  'location_coordinates_missing',
  'warehouse_location_coordinates_missing'
]

// Drift guard (issue 24962): a silent key that stops existing in
// SHIPMENT_GPS_FAIL_REASONS silently re-introduces the bug where the driver
// picker shows a reason that must not be selectable. Fail loudly instead.
const assertShipmentReasonsMatchEnumKeys = (failReasons, silentReasons) => {
  const missing = silentReasons.filter(
    (key) => !Object.prototype.hasOwnProperty.call(failReasons, key)
  )
  if (missing.length > 0) {
    throw new Error(`SHIPMENT_GPS_SILENT_REASONS keys missing from SHIPMENT_GPS_FAIL_REASONS: ${missing.join(', ')}`)
  }
}

assertShipmentReasonsMatchEnumKeys(SHIPMENT_GPS_FAIL_REASONS, SHIPMENT_GPS_SILENT_REASONS)

const SHIPMENT_OTP_FAIL_REASONS = {
  noPassword: 'I was not given any otp',
  noMatch: 'I was given the otp but it’s not working'
}

const SHIPMENT_PRODUCT_MARKETS = {
  origin_sku: 'originSKU',
  destination_sku: 'destinationSKU'
}

const SHIPMENT_VERSIONS = {
  VERSION_1: '1.0.0',
  VERSION_2: '2.0.0'
}

const SHIPMENT_COLLECTOR_TYPES = {
  FACILITY_APP_USER: 'facility_app_user',
  FACILITY_STAFF: 'facility_staff',
  THIRD_PARTY_CARRIER: 'third_party_carrier'
}

const isValidCollectorType = value => Object.values(SHIPMENT_COLLECTOR_TYPES).includes(value)

const OUTBOUND_TEMPLATE_COLUMNS = {
  DESTINATION_NAME: 'Destination Name',
  DESTINATION_WAREHOUSE_CODE: 'Destination Warehouse Code',
  PRODUCT_NAME: 'Product Name',
  PRODUCT_CODE: 'Product Code',
  PRODUCT: 'Product',
  QUANTITY: 'Quantity',
  ORIGIN_WAREHOUSE_CODE: 'Origin Warehouse Code',
  EXTERNAL_ID: 'External Id',
  DATE: 'Date',
  BATCH_NO: 'Batch No',
  MANUFACTURER: 'Manufacturer',
  EXPIRY: 'Expiry',
  SERVICE_ID: 'Service Id'
}

const OUTBOUND_SHIPMENT_TEMPLATE_HEADERS = {
  // Headers for CSV parser in agave
  AGAVE_CSV: [
    OUTBOUND_TEMPLATE_COLUMNS.DESTINATION_WAREHOUSE_CODE,
    OUTBOUND_TEMPLATE_COLUMNS.PRODUCT_CODE,
    OUTBOUND_TEMPLATE_COLUMNS.QUANTITY,
    OUTBOUND_TEMPLATE_COLUMNS.ORIGIN_WAREHOUSE_CODE,
    OUTBOUND_TEMPLATE_COLUMNS.EXTERNAL_ID,
    OUTBOUND_TEMPLATE_COLUMNS.DATE,
    OUTBOUND_TEMPLATE_COLUMNS.MANUFACTURER,
    OUTBOUND_TEMPLATE_COLUMNS.EXPIRY,
    OUTBOUND_TEMPLATE_COLUMNS.BATCH_NO,
    OUTBOUND_TEMPLATE_COLUMNS.SERVICE_ID,
    OUTBOUND_TEMPLATE_COLUMNS.PRODUCT
  ],

  // Note: "DESTINATION_NAME" and "PRODUCT_NAME" are visual aids for guiding users filling the excel sheet
  // They get stripped out during upload(Excel-to-CSV conversion)
  EXCEL_TEMPLATE: [
    OUTBOUND_TEMPLATE_COLUMNS.DESTINATION_NAME,
    OUTBOUND_TEMPLATE_COLUMNS.DESTINATION_WAREHOUSE_CODE,
    OUTBOUND_TEMPLATE_COLUMNS.PRODUCT_NAME,
    OUTBOUND_TEMPLATE_COLUMNS.PRODUCT_CODE,
    OUTBOUND_TEMPLATE_COLUMNS.QUANTITY,
    OUTBOUND_TEMPLATE_COLUMNS.ORIGIN_WAREHOUSE_CODE,
    OUTBOUND_TEMPLATE_COLUMNS.EXTERNAL_ID,
    OUTBOUND_TEMPLATE_COLUMNS.DATE,
    OUTBOUND_TEMPLATE_COLUMNS.BATCH_NO,
    OUTBOUND_TEMPLATE_COLUMNS.MANUFACTURER,
    OUTBOUND_TEMPLATE_COLUMNS.EXPIRY,
    OUTBOUND_TEMPLATE_COLUMNS.SERVICE_ID
  ]
}

module.exports = {
  SHIPMENT_ADVANCE_STATUSES,
  SHIPMENT_STATUS,
  SHIPMENT_STATUS_TO_LMD_DISPLAY_STATUS,
  SHIPMENT_STATUS_TO_LMD_DISPLAY_STATUS_FOR_DRIVER,
  SHIPMENT_GPS_FAIL_REASONS,
  SHIPMENT_GPS_SILENT_REASONS,
  SHIPMENT_OTP_FAIL_REASONS,
  SHIPMENT_PRODUCT_MARKETS,
  SHIPMENT_VERSIONS,
  SHIPMENT_COLLECTOR_TYPES,
  isValidCollectorType,
  SHIPMENT_ADJUSTMENT_REASONS,
  OUTBOUND_SHIPMENT_TEMPLATE_HEADERS,
  OUTBOUND_TEMPLATE_COLUMNS,
  assertShipmentReasonsMatchEnumKeys
}
